<template>
  <div class="app-streaming">
    <div class="top">
      <img class="cover" :src="item.thumbnail || 'https://ah.download.ahedu.cn/rrt/a81f5c66-40c2-40dd-a290-10bcda553711.png'" alt="" />
      <div class="info">
        <el-tooltip class="item" effect="dark" :content="item.name" placement="top" :disabled="item.name.length < 12">
          <h6 class="title">{{ item.name }}</h6>
        </el-tooltip>

        <p class="status">{{ statusObj[item.status] }}</p>
        <el-button class="streaming-button" v-if="[1,2].includes(item.status)" @click="goLive(item)">
          {{item.status === 1 ? '进入直播' : '回看直播'}}
        </el-button>
      </div>
    </div>
    <div class="bottom"><i class="el-icon-time"></i>
      直播时间: {{item.startTime}} 至 {{item.endTime}}
    </div>
  </div>
</template>
<script>
export default {
  name: "",
  components: {},
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      statusObj: {
        0: "未开始",
        1: "正在进行",
        2: "已结束",
      },
    };
  },
  methods: {
    goLive(item) {
      // if (item.status === 1) {
      //   window.open(item.liveUrl, "_blank");
      //   return;
      // }
      if (item.status === 1) {
        let href = this.$router.resolve({
          name: "live",
          query: {
            liveId: item.liveId,
          },
        });
        window.open(href.href, "_blank");
      } else {
        let routeData = this.$router.resolve({ path: '/archive-detail', query: { detailId: item.liveId } });
        window.open(routeData.href, '_blank');
      }  
    },
  },
};
</script>
<style scoped lang="less">
.app-streaming {
  box-sizing: border-box;
  display: inline-block;
  margin: 18px 24px 24px 0;
  width: 587px;
  height: 214px;
  padding: 24px;
  background: linear-gradient(180deg, #fafbff 0%, #ffffff 100%);
  box-shadow: 0px 2px 20px 0px rgba(119, 135, 182, 0.17);
  border: 2px solid;
  border-image: linear-gradient(
      180deg,
      rgba(255, 255, 255, 1),
      rgba(247, 248, 251, 0)
    )
    2 2;
  .top {
    height: 100px;
    display: flex;
    width: 100%;
    .cover {
      width: 258px;
      height: 144px;
      transform: translateY(-44px);
      margin-right: 20px;
    }
    .info {
      flex: 1;
      overflow: hidden;
      .title {
        height: 30px;
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        line-height: 18px;
        width: 100%;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
      .status {
        text-align: center;
        margin: 10px 0;
        width: 50px;
        height: 18px;
        background: #9099b8;
        font-size: 12px;
        font-family: MicrosoftYaHei;
        color: #ffffff;
        line-height: 18px;
      }
      .streaming-button {
        width: 90px;
        height: 32px;
        padding: 0;
        font-size: 14px;
        font-family: PingFang-SC-Medium, PingFang-SC;
        font-weight: 500;
        line-height: 20px;
        border-color: #368fff !important;
        color: #368fff !important;
        &:hover {
          background: #fff;
        }
      }
    }
  }
  .bottom {
    margin-top: 24px;
    width: 539px;
    height: 40px;
    background: #eef5ff;
    padding: 0 10px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #8c8c8c;
    line-height: 40px;
  }
}
</style>